var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('reseller-form',{attrs:{"model":_vm.reseller,"newReseller":true,"type":"create","titlePrefix":_vm.$t('partner.create.texts.title-prefix')},on:{"saved":_vm.saved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }